module.exports = __webpack_public_path__ + "static/media/AKRO.a2831944.svg";